<template>
    <div id="app" class="app" v-if="alive">
        <!-- 适配样式 -->
        <div class="app-bg" :class="{
            Tickets: this.$route.name == 'submit a ticket',
            Login: this.$route.name == 'Login',
            Nfind: this.$route.name == 'Nfind',
            Bind: this.$route.name == 'Bind',
            Content: this.$route.name == 'KNOW ISSUES',
        }">
            <app-header @setLang="setLang" v-if="header_show"></app-header>
            <app-topalert v-if="topalert_show"></app-topalert>

            <router-view v-on:header="header" v-on:footer="footer" v-if="isRouterAlive" />
            <!-- <footer-nav></footer-nav> -->
            <app-footer @setLang="setLang" v-if="footer_show" :lang="preferredLang"></app-footer>
        </div>
    </div>
</template>
<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Topalert from "./components/Topalert.vue";
import Loading from "./components/Loading.vue";
import i18n from "./lang";
import Vue from 'vue';
import { resolve } from "path";
export default {
    name: "App",
    provide() {
        return {
            reload: this.reload,
            loading: this.loading,
            stopLoading: this.stopLoading
        }
    },
    watch: {
        $route(to, from) {
            if (to.name != from.name) {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

            }
        },

    },
    data() {
        return {
            bg: "",
            udesk: "",
            header_show: true,
            footer_show: true,
            topalert_show: true,
            alive: false,
            m: "",
            i: "",
            s: "",
            preferredLang: "en", // {en, zh} 用户语言

            topalert: [],
            isRouterAlive: false
        };
    },
    components: {
        "app-header": Header,
        "app-footer": Footer,
        "app-topalert": Topalert,
        Loading
    },
    mounted() {
        
        console.log(this.$backend);
        console.log('11111');
        //筛选浏览器
        this.checkBro();
        // wait for udesk ready
        this.waitForUdeskReady(() => {
            this.getPreferLang();
            if (this.$route.query.result_code) {
                console.log('我看看', this.$route.query.result_code);
                this.$cookie.set('result_code', this.$route.query.result_code, { path: '/' })
                localStorage.setItem('result_code', this.$route.query.result_code);

                // document.cookie = "result_code=" + this.$route.query.result_code + ';path = /';
                console.log(this.$route.query.CustIdGame);
                this.$cookie.set('cust_id_game', this.$route.query.CustIdGame == '_' ? '' : this.$route.query.CustIdGame, { path: '/' })


                // if has parent window  
                // //&& this.$store.state.custId == ""
                if (window.opener) {
                    window.opener.location.href = '/'
                    window.close()
                }
            }
            var lang = i18n.locale == 'zh' ? '/zh-cn' : '/en-us'
            Vue.prototype.$udesk.init()

            Promise.all([
                new Promise((resolve) => {
                    this.$axios({
                        method: 'get',
                        url: this.$backend.wpHost + '/categories?_fields=description,count,id,name,count,slug',
                    }).then(res => {
                        res.data.map(it => {
                            console.log(it);
                            if (it.slug == 'announcement') {
                                console.log(it.slug);
                                this.$axios({
                                    method: 'get',
                                    url: this.$backend.wpHost + '/posts?categories=' + it.id + '&orderby=modified&order=desc',
                                }).then(result => {
                                    console.log(result);
                                    const data = []
                                    result.data.map(item => {
                                        if (!this.getCookie('top_alert_id').includes(item.date)) {
                                            data.push(item)
                                        }
                                    })
                                    this.$store.commit("SaveTopAlert", data);

                                }).catch(err => {
                                    console.log(err);
                                    resolve([]);
                                });
                            }
                        })
                        resolve(res.data);
                    }).catch(err => {
                        console.log(err);
                        resolve([]);
                    });
                }),

                new Promise((resolve) => {
                    this.$axios({
                        method: 'get',
                        url: this.$backend.wpHost + '/posts?_fields=id,title,categories,slug&per_page=100&page=1&orderby=modified&order=desc',
                    }).then(res => {
                        resolve(res.data);
                    }).catch(err => {
                        console.log(err);
                        resolve([]);
                    });
                }),

            ]).then(([categories, posts]) => {
                // 将分类和文章进行匹配
                const categorizedPosts = categories.map(category => ({
                    ...category,
                    posts: posts.filter(post => post.categories.includes(category.id)),
                }));
                
                console.log(categorizedPosts);
                const allClass = []
                categorizedPosts.map(item => {
                    // 推荐模块1 2 和公告剔除
                    console.log(item);
                    if (item.slug == "announcement") {
                    } else if (item.slug == "recommended_article_1") {
                        this.$store.commit("SaveInformationOne", item);
                    } else if (item.slug == "none") {

                    } else if (item.slug == "recommended_article_2") {
                        this.$store.commit("SaveInformationTwo", item);
                    } else {
                        allClass.push(item);
                    }
                })
                this.$store.commit("SaveClass", allClass)


                this.isRouterAlive = true

            });

            this.$udesk
            var count = 0
            let timer = setInterval(() => {
                count++
                if (count >= 50) {
                    clearInterval(timer)
                }
                console.log(count);
                console.log(this.$udesk.getDataReady, this.isRouterAlive);
                if (this.$udesk.getDataReady && this.isRouterAlive) {
                    this.alive = true
                    clearInterval(timer)
                }
            }, 1000)

        })
    },
    beforeMount() {
        this.getPreferLang();
    },
    methods: {

        getCookie(name) {
            var strcookie = document.cookie; //获取cookie字符串
            var arrcookie = strcookie.split("; "); //分割
            //遍历匹配
            for (var i = 0; i < arrcookie.length; i++) {
                var arr = arrcookie[i].split("=");
                if (arr[0] == name) {
                    return arr[1];
                }
            }
            return "";
        },
        waitForUdeskReady(cb) {
            var u = this.$udesk

            if (u.isReady == true && this.$backend.isReady) {

                cb()
                return
            }
            function wait() {
                if (u.isReady == true && Vue.prototype.$backend.isReady) {

                    cb()
                }
                else {
                    setTimeout(wait, 250);
                }
            }
            wait()
        },
        loading() {
            this.$refs.loading.loading()
        },
        stopLoading() {
            this.$refs.loading.close()
        },
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
        checkBro() {
            var u = navigator.userAgent;

            if (
                /macintosh|mac os x/i.test(navigator.userAgent) ||
                u.indexOf("Linux") > -1
            ) {
                this.m = true;

                if (!u.indexOf("Android") > -1 && u.indexOf("iPhone") > -1) {
                    this.i = true;
                }
                if (
                    /Safari/.test(navigator.userAgent) &&
                    !/Chrome/.test(navigator.userAgent)
                ) {
                    // this.m = false
                    this.s = true;
                }
            }

            return {
                trident: u.indexOf("Trident") > -1, //IE内核
                presto: u.indexOf("Presto") > -1, //opera内核
                mac: /macintosh|mac os x/i.test(navigator.userAgent),
                webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
                gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
                iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf("iPad") > -1, //是否iPad
                webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            };
        },
        getPreferLang() {
            let preferredLang =
                localStorage.getItem("preferredLang") ||
                navigator.language ||
                navigator.userLanguage ||
                navigator.browserLanguage ||
                "en";
            console.log(preferredLang);
            preferredLang = preferredLang.toLowerCase();
            preferredLang = preferredLang.substr(0, 2);
            console.log(preferredLang);
            if (!/(en)|(zh)/.test(preferredLang)) {
                console.log("navigator language is not supported");
                preferredLang = "en";
            }
            document.documentElement.lang = preferredLang;
            this.preferredLang = preferredLang;
            i18n.locale = preferredLang;
        },
        setLang(lang) {
            if (this.preferredLang !== lang) {
                this.preferredLang = lang;
                localStorage.setItem("preferredLang", lang);
                document.documentElement.lang = lang;
                i18n.locale = lang;
                if (Object.prototype.hasOwnProperty.call(window, "scrollTo")) {
                    scrollTo(0, 0);
                } else {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }
            }
        },
        //是否显示头部
        header: function (bool) {
            this.header_show = bool;
        },
        //是否显示底部
        footer: function (bool) {
            this.footer_show = bool;
        },
    },
};
</script>

<style lang="scss" scoped>
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
// 全局样式
@import url("assets/scss/app.scss");
// Safari
@import url("assets/scss/safari.scss");
// 手机/mac/iphone
@import url("assets/scss/mac.scss");
// iphone
@import url("assets/scss/iphone.scss");

// 字体文件
@import url("assets/scss/font.scss");
// udesk
// @import url("assets/scss/udesk.scss");
::v-deep .el-scrollbar {
    border-radius: 17px;

    >.el-scrollbar__bar {
        border-radius: 17px;
        opacity: 1 !important;
    }
}
//全篇背景
.Tickets {
    background: url("./assets/images/submit_bg.png") top repeat;
}

.Login {
    background: url("./assets/images/email_bg.png") center repeat;
    height: 100%;
}

.Bind {
    background: url("./assets/images/submit_bg.png") center repeat;
    height: 100%;
}
.Content{
    background: url("./assets/images/submit_bg.png")center repeat;
}
.Nfind {
    background: url("./assets/images/404_bg.png") center repeat;
}
</style>
